import { render } from "./Adhoc.vue?vue&type=template&id=0b1992d8&scoped=true"
import script from "./Adhoc.vue?vue&type=script&lang=js"
export * from "./Adhoc.vue?vue&type=script&lang=js"

import "./Adhoc.vue?vue&type=style&index=0&id=0b1992d8&scoped=true&lang=css"

import exportComponent from "/Users/jinming/Documents/jhapps/frontendadmin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b1992d8"]])

export default __exports__